import type { Dayjs } from 'dayjs';

const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
export function getWeekdays(day: number) {
  return weekdays[day];
}

export function getDayList({
  startTime,
  endTime,
}: {
  startTime: Dayjs;
  endTime: Dayjs;
}) {
  const dateArray = [];
  let currentTime = startTime;
  while (currentTime <= endTime) {
    // const formattedDate = `${currentTime.format('MM.DD')} ${getWeekdays(
    //   currentTime.day()
    // )}`;
    dateArray.push(currentTime.format('YYYY-MM-DD'));
    currentTime = currentTime.add(1, 'day');
  }

  return dateArray;
}
